import React from 'react';
import {Grid2, TextField, Typography} from '@mui/material';
import {t} from 'ttag';
import {Controller, FieldValues, FormProvider, UseFormReturn} from 'react-hook-form';
import CountrySelector from '@components/country-selector/CountrySelector';

export const InvoiceEditForm = (methods: UseFormReturn<FieldValues>) => {
  return (
    <FormProvider {...methods}>
      <Grid2 container spacing={2}>
        <Grid2 size={{xs: 12}}>
          <Typography variant={'body2'} fontFamily={'OpenSansMedium'} mb={1}>
            {t`Billing Name`}
          </Typography>
          <Controller
            name={'billingName'}
            control={methods.control}
            render={({field, fieldState}) => (
              <TextField
                {...field}
                fullWidth
                variant={'outlined'}
                size={'small'}
                color={'secondary'}
                placeholder={t`Name`}
                error={!!fieldState.error}
                helperText={fieldState?.error?.message}
              />
            )}
          />
        </Grid2>
        <Grid2 size={{xs: 12}}>
          <Typography variant={'body2'} fontFamily={'OpenSansMedium'} mb={1}>
            {t`Endorsement`}
          </Typography>
          <Controller
            name={'endorsement'}
            control={methods.control}
            render={({field, fieldState}) => (
              <TextField
                {...field}
                fullWidth
                variant={'outlined'}
                size={'small'}
                color={'secondary'}
                placeholder={t`Endorsement`}
                error={!!fieldState.error}
                helperText={fieldState?.error?.message}
              />
            )}
          />
        </Grid2>
        <Grid2 size={{xs: 12, sm: 6}}>
          <Typography variant={'body2'} fontFamily={'OpenSansMedium'} mb={1}>
            {t`Tax ID`}
          </Typography>
          <Controller
            name={'taxId'}
            control={methods.control}
            render={({field, fieldState}) => (
              <TextField
                {...field}
                fullWidth
                variant={'outlined'}
                size={'small'}
                color={'secondary'}
                placeholder={t`Tax ID`}
                error={!!fieldState.error}
                helperText={fieldState?.error?.message}
              />
            )}
          />
        </Grid2>
        <Grid2 size={{xs: 12, sm: 6}}>
          <Typography variant={'body2'} fontFamily={'OpenSansMedium'} mb={1}>
            {t`Email`}
          </Typography>
          <Controller
            name={'email'}
            control={methods.control}
            render={({field, fieldState}) => (
              <TextField
                {...field}
                fullWidth
                variant={'outlined'}
                size={'small'}
                color={'secondary'}
                placeholder={t`Email`}
                error={!!fieldState.error}
                helperText={fieldState?.error?.message}
              />
            )}
          />
        </Grid2>
        <Grid2 size={{xs: 12}}>
          <Typography variant={'body2'} fontFamily={'OpenSansMedium'} mb={1}>
            {t`Address`}
          </Typography>
          <Controller
            name={'address'}
            control={methods.control}
            render={({field, fieldState}) => (
              <TextField
                {...field}
                fullWidth
                variant={'outlined'}
                size={'small'}
                color={'secondary'}
                placeholder={t`Address`}
                error={!!fieldState.error}
                helperText={fieldState?.error?.message}
              />
            )}
          />
        </Grid2>
        <Grid2 size={{xs: 6}}>
          <Typography variant={'body2'} fontFamily={'OpenSansMedium'} mb={1}>
            {t`Postal Code`}
          </Typography>
          <Controller
            name={'postalCode'}
            control={methods.control}
            render={({field, fieldState}) => (
              <TextField
                {...field}
                fullWidth
                variant={'outlined'}
                size={'small'}
                color={'secondary'}
                placeholder={t`Postal Code`}
                error={!!fieldState.error}
                helperText={fieldState?.error?.message}
              />
            )}
          />
        </Grid2>
        <Grid2 size={{xs: 6}}>
          <Typography variant={'body2'} fontFamily={'OpenSansMedium'} mb={1}>
            {t`City`}
          </Typography>
          <Controller
            name={'city'}
            control={methods.control}
            render={({field, fieldState}) => (
              <TextField
                {...field}
                fullWidth
                variant={'outlined'}
                size={'small'}
                color={'secondary'}
                placeholder={t`City`}
                error={!!fieldState.error}
                helperText={fieldState?.error?.message}
              />
            )}
          />
        </Grid2>
        <Grid2 size={{xs: 6}}>
          <Typography variant={'body2'} fontFamily={'OpenSansMedium'} mb={1}>
            {t`Country`}
          </Typography>
          <Controller
            name={'country'}
            control={methods.control}
            render={({field, fieldState}) => (
              <CountrySelector
                {...field}
                size={'small'}
                error={fieldState.error}
              />
            )}
          />
        </Grid2>
      </Grid2>
    </FormProvider>
  );
};
